import { render, staticRenderFns } from "./OrderFound.vue?vue&type=template&id=fce73adc&"
import script from "./OrderFound.vue?vue&type=script&lang=js&"
export * from "./OrderFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports